import papa from 'vue-papa-parse'

export default ({ app }) => {
  app.use(papa)
}
